import { Injectable } from '@angular/core';

@Injectable()
export class NumberService {
	constructor() {
	}

	getNumber(value: string, options: NumberOptions): number {
		const regex = new RegExp('\\' + options.thousandSeparator, 'g');
		const numberValue = parseFloat(value.replace(regex, '').replace(options.decimalSeparator, '.'));
		return isNaN(numberValue) ? 0 : numberValue;
	}

	formatNumber(value: number | undefined, numberOfDecimals: number | undefined, options: NumberOptions): string {
		if (value === undefined || isNaN(value)) return '';
		if (numberOfDecimals === undefined) numberOfDecimals = 0;

		let tmpNum = value;
		tmpNum *= Math.pow(10, numberOfDecimals);
		tmpNum = Math.round(Math.abs(tmpNum));
		tmpNum /= Math.pow(10, numberOfDecimals);
		let tmpNumStr = tmpNum.toFixed(numberOfDecimals);

		if (tmpNumStr.indexOf('.') >= 0) {
			tmpNumStr = tmpNumStr.replace('.', options.decimalSeparator);
		}
		if (options.showThousandSeperator && (value >= 1000 || value <= -1000)) {
			var iStart = tmpNumStr.indexOf(options.decimalSeparator);
			if (iStart < 0) {
				iStart = tmpNumStr.length;
			}

			iStart -= 3;
			while (iStart >= 1) {
				tmpNumStr = tmpNumStr.substring(0, iStart) + options.thousandSeparator + tmpNumStr.substring(iStart, tmpNumStr.length)
				iStart -= 3;
			}
		}
		if (value < 0) tmpNumStr = '- ' + tmpNumStr;
		return tmpNumStr;
	}
}

export class NumberOptions {
	showThousandSeperator: boolean;
	thousandSeparator: string = '.';
	decimalSeparator: string = ',';

	constructor(showThousandSeperator: boolean = true) {
		this.showThousandSeperator = showThousandSeperator;
	}
}
